import { render, staticRenderFns } from "./supplier-contract-edit.vue?vue&type=template&id=48b21e35&scoped=true"
import script from "./supplier-contract-edit.vue?vue&type=script&lang=js"
export * from "./supplier-contract-edit.vue?vue&type=script&lang=js"
import style0 from "./supplier-contract-edit.vue?vue&type=style&index=0&id=48b21e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b21e35",
  null
  
)

export default component.exports